export default __webpack_public_path__ + "static/media/Home-foto-header-partners-Tower-viajes-desk@2x.061e2ade.jpg";